import { type DraggableItems } from '@/types/dragDrop';
import { t } from '@/i18n/translator';

export const MoveNodeCommand = (
  moveNodes: any,
  oldParentFolderNodeId: string,
  nodes: Array<string>,
  type: DraggableItems,
  parentFolderNodeId?: string,
  options?: { suppressGlobalErrorToast?: boolean },
) => {
  const apply = () => moveNodes([{ parentFolderNodeId, nodes }], options);
  const undo = () => {
    void moveNodes([{ parentFolderNodeId: oldParentFolderNodeId, nodes }]);
  };
  const redo = () => apply();

  return {
    apply,
    undo,
    redo,
    message: t('commands.moveNode', { type: type ?? 'node' }),
  };
};
